/*
 * @Description:
 * @Date: 2024-01-26 09:21:17
 */
const isFirefox = navigator.userAgent.indexOf('Firefox') > -1;

type TableHeaderListType = Array<{
  label: Array<string>;
  prop: string;
  width?: string;
  group?: boolean;
  rowspan?: number;
  colspan?: number;
  subHeaderList?: TableHeaderListType;
  del?: boolean;
  align?: 'left' | 'center';
}>;
export const useTable = (
  tableHeaderList: TableHeaderListType,
  className = '',
  attrs = ''
) => {
  const _maxRow: number = (() => {
    const add = (arr: TableHeaderListType) => {
      const hasSubItems = arr.filter(
        item =>
          Array.isArray(item.subHeaderList) && item.subHeaderList.length > 0
      );
      return hasSubItems.length > 0
        ? Math.max(
            ...hasSubItems.map(item =>
              add(item.subHeaderList as TableHeaderListType)
            )
          ) + 1
        : 1;
    };
    return add(tableHeaderList);
  })();
  const _dealTableData = (
    tableDataList: Array<{ [key: string]: Array<string> }>
  ) => {
    const getKeys = (arr: TableHeaderListType) => {
      return arr.reduce((pre, cur) => {
        if (Array.isArray(cur.subHeaderList) && cur.subHeaderList.length > 0) {
          pre.push(...getKeys(cur.subHeaderList));
        } else {
          pre.push({
            prop: cur.prop,
            group: !!cur.group,
            rowspan: 1,
            colspan: 1
          });
        }
        return pre;
      }, [] as Array<{ prop: string; group: boolean; rowspan?: number; colspan?: number; del?: boolean }>);
    };
    const allRowKeys = getKeys(tableHeaderList);
    const groupKeys = [...allRowKeys.filter(i => i.group).map(i => i.prop)];
    const resKeys: Array<typeof allRowKeys> = tableDataList.map(() => [
      ...allRowKeys.map(i => ({ ...i }))
    ]);
    const getLastCommonValIndex = (
      val: string,
      key: string,
      nextIndex: number
    ) => {
      if (val === void 0) return nextIndex;
      if (val === tableDataList[nextIndex]?.[key]?.[0]) {
        return getLastCommonValIndex(val, key, nextIndex + 1);
      }
      return nextIndex;
    };

    for (let index = 0; index < tableDataList.length; index++) {
      groupKeys.forEach(key => {
        const checkVal = tableDataList[index][key][0];
        const lastCommonValIndex = getLastCommonValIndex(
          checkVal,
          key,
          index + 1
        );
        const infoIndex = resKeys[index].findIndex(item => item.prop === key);
        for (let i = index; i < lastCommonValIndex; i++) {
          if (i === index) {
            resKeys[i][infoIndex] &&
              (resKeys[i][infoIndex].rowspan = lastCommonValIndex - index);
          } else {
            const _index = resKeys[i].findIndex(item => item.prop === key);
            resKeys[i][_index].del = true;
          }
        }
      });
    }

    return resKeys.map(k =>
      k.map(i => ({ ...i, rowspan: i.del ? 0 : i.rowspan }))
    );
  };

  const _tableHeaderListForHeader = (() => {
    const res: Array<TableHeaderListType> = [];
    let _headerListData = [...tableHeaderList];
    const getColsspan = (arr?: TableHeaderListType) => {
      if (!arr) return 1;
      return arr.reduce((pre, cur) => {
        if (Array.isArray(cur.subHeaderList) && cur.subHeaderList.length > 0) {
          pre += getColsspan(cur.subHeaderList);
        } else {
          pre += 1;
        }
        return pre;
      }, 0);
    };
    for (let row = 0; row < _maxRow; row++) {
      res[row] = [];
      const _newHeaderListData: TableHeaderListType = [];
      _headerListData.forEach(item => {
        const hasSub =
          Array.isArray(item.subHeaderList) && item.subHeaderList?.length > 0;
        res[row].push({
          ...item,
          rowspan: hasSub ? 1 : _maxRow - row,
          colspan: getColsspan(item.subHeaderList)
        });
        if (hasSub) {
          _newHeaderListData.push(...(item.subHeaderList || []));
        }
      });
      _headerListData = _newHeaderListData;
    }
    return res;
  })();

  const _headerGap = (() =>
    _tableHeaderListForHeader[0].map(i => i.rowspan == _maxRow))();
  const colWidth = (() => {
    return `${
      100 /
      _tableHeaderListForHeader[0].reduce((pre, cur) => {
        return pre + (cur.colspan || 0);
      }, 0)
    }%`;
  })();
  const _dataGap = (
    () => () =>
      _tableHeaderListForHeader[0].reduce((pre, cur) => {
        pre.push(...new Array(cur.colspan).fill(cur.rowspan == _maxRow));
        return pre;
      }, [])
  )();
  const _emptyData = (() =>
    tableHeaderList.reduce((pre, cur) => {
      pre[cur.prop] = !cur.label.every(Boolean);
      return pre;
    }, {}))();

  const createTable = (
    tableDataList: Array<{ [key: string]: Array<string> }>,
    hideHeader?: boolean,
    hideBody?: boolean
  ) => {
    if (!Array.isArray(tableDataList)) return '';
    const tableHeaderListForData = _dealTableData(tableDataList);
    return `
    <table class="custom-table-for-cmpt ${className}" ${attrs}>
      <colgroup>
      ${_tableHeaderListForHeader[0]
        ?.map(
          header => `
          <col width="${header.width || colWidth}"></col>
        `
        )
        .join('')}
      </colgroup>
      <thead ${hideHeader ? 'style="display:none;"' : ''}>
        ${_tableHeaderListForHeader
          .map((headers, index) => {
            return `
          <tr>
            ${headers
              .map((header, colIndex) => {
                const className = Object.entries({
                  gap: _headerGap[colIndex] && index == 0,
                  normal: !_headerGap[colIndex] && index == 0,
                  empty: !header.label[0]
                })
                  .filter(([_key, value]) => value)
                  .map(([_key]) => _key)
                  .join(' ');
                return `
              <th width="${header.width || colWidth}" rowspan="${
                  header.rowspan
                }" colspan="${header.colspan}" class="${className}">
                <div style="${
                  isFirefox
                    ? `height:calc(var(--header-cell-height, 60px) * ${
                        header.rowspan || 1
                      });`
                    : ''
                }">${
                  header.label.length > 1
                    ? '分类指标'
                    : [void 0, null].includes(header.label[0])
                    ? ''
                    : header.label[0]
                }</div>
              </th>`;
              })
              .join('')}
          </tr>`;
          })
          .join('')}
      </thead>
      <tbody ${hideBody ? 'style="display:none;"' : ''}>
        ${tableHeaderListForData
          .map((tableKeyItem, index) => {
            return `
          <tr class="${
            tableKeyItem.some(i => i.rowspan && i.rowspan > 1)
              ? 'has-group'
              : ''
          }">
            ${tableKeyItem
              .map(({ prop, rowspan }, cindex) => {
                const className = Object.entries({
                  group: rowspan && rowspan > 1,
                  gap: _dataGap[cindex],
                  normal: !_dataGap[cindex],
                  'header-empty': _emptyData[prop]
                })
                  .filter(([_key, value]) => value)
                  .map(([_key]) => _key)
                  .join(' ');
                const value = tableDataList[index][prop]?.[0];
                return `
                <td class="${className} ${
                  ['', void 0, null].includes(value) ? 'empty' : ''
                }" rowspan="${rowspan}">
                  <div style="${
                    isFirefox
                      ? `height:calc(var(--body-cell-height, 60px) * ${
                          rowspan || 1
                        } + calc(var(--gap, 0pt)) * ${rowspan || 1});`
                      : ''
                  } ${(() =>
                  _tableHeaderListForHeader[0]?.[cindex]?.align === 'left'
                    ? 'justify-content:flex-start;text-align:left;'
                    : '')()}">${
                  [void 0, null].includes(value)
                    ? ''
                    : `${value}`.replaceAll('(', ' (')
                }</div>
                </td>
              `;
              })
              .join('')}
          </tr>
          `;
          })
          .join('')}
      </tbody>
    </table>
    `;
  };

  return { createTable };
};
